module.exports = __webpack_public_path__ + "static/media/EnvelopeSimple.af597336.svg";